import { AbstractType, FactoryProvider, InjectionToken, Injector, Type } from '@angular/core';
import { WALLBOARD_PATH } from '@nimbus-portal/features/wallboard/models/wallboard.const';

export enum AppMode {
  Default = 'default',
  Wallboard = 'wallboard',
}

export function resolveAppMode(pathname: string): AppMode {
  const isWallboard = pathname === WALLBOARD_PATH || pathname.startsWith(`${WALLBOARD_PATH}/`);
  return isWallboard ? AppMode.Wallboard : AppMode.Default;
}

export const APP_MODE = new InjectionToken<AppMode>('APP_MODE', {
  providedIn: 'root',
  factory: (): AppMode => resolveAppMode(window.location.pathname),
});

type AppModeImplementations<T> = { [AppMode.Default]: Type<T> } & Partial<Record<AppMode, Type<T>>>;

export function appModeProvider<T>(token: AbstractType<T>, implementations: AppModeImplementations<T>): FactoryProvider {
  return {
    provide: token,
    useFactory: (injector: Injector, mode: AppMode): T => injector.get(implementations[mode] ?? implementations[AppMode.Default]),
    deps: [Injector, APP_MODE],
  };
}
